import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CodeManagementIndexComponent, LanguagePackIndexComponent, ReportIndexComponent, FMIProductIndexComponent, SurveyIndexComponent, PMDocumentIndexComponent, PMUserIndexComponent, PartsManualIndexComponent } from './index';
import { CanActivateGuard } from './../shared/index';

export const AdministrationRoutes: Routes = [
    {
        path: 'administration/codemanagement',
        component: CodeManagementIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'administration/languagepack',
        component: LanguagePackIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'administration/reports',
        component: ReportIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'administration/fmiproduct',
        component: FMIProductIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'administration/survey',
        component: SurveyIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'administration/pmdocuments',
        component: PMDocumentIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'administration/partsmanual',
        component: PartsManualIndexComponent,
        canActivate: [CanActivateGuard]
    },
    {
        path: 'administration/pmusers',
        component: PMUserIndexComponent,
        canActivate: [CanActivateGuard]
    }
];

export const AdministrationRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(AdministrationRoutes);
